export const ITEMS_PER_PAGE = 10;

export const INITIAL_ORDER_STATE = {
  uuid_destination_warehouse: '',
  uuid_project: '',
  needed_date: '',
  needed_time: '',
  observations: '',
  materials: [],
};

export const getInitialOrderState = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');

  return {
    ...INITIAL_ORDER_STATE,
    needed_date: now.toISOString().split('T')[0],
    needed_time: `${hours}:${minutes}`,
  };
};

export const ORDER_STATUS_LABELS = {
  pending_authorization: 'Pendiente de autorización',
  received: 'Recibido',
  checking_stock: 'Controlando stock',
  stock_available: 'Stock disponible',
  awaiting_transfer: 'Pendiente de traslado',
  ready_to_consume: 'Listo para consumir',
  consumed: 'Consumido',
  cancelled: 'Cancelado',
  failed: 'Fallido',
};

export const ORDER_STATUS_COLORS = {
  pending_authorization: 'warning',
  received: 'info',
  checking_stock: 'info',
  stock_available: 'success',
  awaiting_transfer: 'warning',
  ready_to_consume: 'primary',
  consumed: 'success',
  cancelled: 'error',
  failed: 'error',
};

export const INITIAL_FILTERS = {
  status: '',
  uuid_destination_warehouse: '',
  uuid_project: '',
  date_from: '',
  date_to: '',
};

export const ORDER_ITEM_STATUS_LABELS = {
  pending: 'Pendiente',
  available: 'Disponible',
  missing: 'Faltante',
  in_transfer: 'En traslado',
  ready: 'Listo',
  consumed: 'Consumido',
  cancelled: 'Cancelado',
};

export const CHECK_STOCK_ORDER_STATUSES = ['received', 'checking_stock'];

export const CANCELLABLE_ORDER_STATUSES = [
  'pending_authorization',
  'received',
  'stock_available',
  'awaiting_transfer',
  'ready_to_consume',
];
